
<tps-assistant-message [role]="'assistant'" [messageContent]="messageText()">
  <div class="body">
    <div class="chip-row">
      @for (suggestion of suggestions(); track suggestion) {
        <ngt-chip [selected]="isSuggestionSelected(suggestion)" (click)="onSelectSuggestion(suggestion)">{{ suggestion }}</ngt-chip>
      }
    </div>
  </div>
</tps-assistant-message>
